import { useNavigate } from 'react-router-dom';
import CrmRecordForm from '../components/crm/CrmRecordForm';
import { CrmRecordHeader, type CrmKind } from '../components/crm/CrmRecordLayout';
import { useCrmNavigation } from '../hooks/useCrmNavigation';

export default function CrmCreate({ kind }: { kind: CrmKind }) {
  const base = kind === 'client' ? '/clients' : '/leads';
  const navigate = useNavigate();
  const { returnTo } = useCrmNavigation(base);
  return <div className="mx-auto max-w-6xl space-y-6">
    <CrmRecordHeader kind={kind} title={kind === 'client' ? 'Nuovo cliente' : 'Nuovo lead'} backTo={returnTo} creating />
    <CrmRecordForm key={kind} kind={kind} onCancel={() => navigate(returnTo)} onSaved={id => navigate(`${base}/${id}`, { replace: true, state: { crmReturnTo: returnTo } })} />
  </div>;
}
